// extracted by mini-css-extract-plugin
export var fullHeightState = "_5i-7";
export var headerCell = "_5i-1";
export var loadingStateCell = "_5i-4";
export var rowWrapper = "_5i-3";
export var standaloneTable = "_5i-8";
export var standaloneTableWithBodyFill = "_5i-9";
export var stateCell = "_5i-5";
export var table = "_5i-0";
export var tableBodyFiller = "_5i-6";
export var white = "_5i-2";